import React from 'react';
import { X } from 'lucide-react';

const ActiveFilters = ({
  filterActive,
  ageRange,
  setAgeRange,
  experienceYearsRange,
  setExperienceYearsRange,
  experienceFilter,
  setExperienceFilter,
  competenceFilter,
  setCompetenceFilter,
  diplomeFilter,
  setDiplomeFilter,
  langueFilter,
  setLangueFilter,
  totalCount,
  currentPage,
  totalPages,
}) => {
  return (
    <div className="mb-4 flex justify-between items-center">
      <p className="text-gray-500">{totalCount} demandeur(s) au total — page {currentPage}/{totalPages}</p>
      
      {filterActive && (
        <div className="flex flex-wrap items-center gap-2">
          {(ageRange.min > 18 || ageRange.max < 65) && (
            <span className="px-3 py-1 bg-gray-100 text-gray-800 rounded-full text-sm flex items-center">
              Âge: {ageRange.min}-{ageRange.max} ans
              <X size={14} className="ml-1 cursor-pointer" onClick={() => setAgeRange({ min: 18, max: 65 })} />
            </span>
          )}
          
          {(experienceYearsRange.min > 0 || experienceYearsRange.max < 20) && (
            <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm flex items-center">
              Exp: {experienceYearsRange.min}-{experienceYearsRange.max} ans
              <X size={14} className="ml-1 cursor-pointer" onClick={() => setExperienceYearsRange({ min: 0, max: 20 })} />
            </span>
          )}
          
          {experienceFilter && (
            <span className="px-3 py-1 bg-orange-100 text-orange-800 rounded-full text-sm flex items-center">
              Domaine: {experienceFilter}
              <X size={14} className="ml-1 cursor-pointer" onClick={() => setExperienceFilter('')} />
            </span>
          )}
          {competenceFilter && (
            <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm flex items-center">
              Comp: {competenceFilter}
              <X size={14} className="ml-1 cursor-pointer" onClick={() => setCompetenceFilter('')} />
            </span>
          )}
          {diplomeFilter && (
            <span className="px-3 py-1 bg-purple-100 text-purple-800 rounded-full text-sm flex items-center">
              Diplôme: {diplomeFilter}
              <X size={14} className="ml-1 cursor-pointer" onClick={() => setDiplomeFilter('')} />
            </span>
          )}
          {langueFilter && (
            <span className="px-3 py-1 bg-indigo-100 text-indigo-800 rounded-full text-sm flex items-center">
              Langue: {langueFilter}
              <X size={14} className="ml-1 cursor-pointer" onClick={() => setLangueFilter('')} />
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default ActiveFilters;
